import { InputTextProps } from '../../../types/InputText';

import styles from './InputText.module.scss';

import type { FC } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

// eslint-disable-next-line max-lines-per-function
export const InputText: FC<InputTextProps> = ({
  type,
  name,
  id,
  width,
  placeholder,
  value,
  defaultValue,
  disable,
  onChange,
  onBlur,
}) => {
  switch (width) {
    case 'default':
      return (
        <>
          {disable ? (
            <input
              name={name}
              id={id}
              className={styles['input-text-default-disable']}
              value={value}
              defaultValue={defaultValue}
              placeholder={placeholder}
              type={type}
              onChange={onChange}
              onBlur={onBlur}
            />
          ) : (
            <input
              name={name}
              id={id}
              className={styles['input-text-default']}
              type={type}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              defaultValue={defaultValue}
              value={value}
            />
          )}
        </>
      );
    case 'wide':
      return (
        <>
          {disable ? (
            <input
              name={name}
              id={id}
              className={styles['input-text-wide-disable']}
              value={value}
              defaultValue={defaultValue}
              placeholder={placeholder}
              type={type}
              onChange={onChange}
              onBlur={onBlur}
            />
          ) : (
            <input
              name={name}
              id={id}
              className={styles['input-text-wide']}
              type={type}
              defaultValue={defaultValue}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
            />
          )}
        </>
      );
    case 'short':
      return (
        <>
          {disable ? (
            <input
              name={name}
              id={id}
              className={styles['input-text-short-disable']}
              value={value}
              defaultValue={defaultValue}
              placeholder={placeholder}
              type={type}
              onChange={onChange}
              onBlur={onBlur}
            />
          ) : (
            <input
              name={name}
              id={id}
              className={styles['input-text-short']}
              value={value}
              defaultValue={defaultValue}
              placeholder={placeholder}
              type={type}
              onChange={onChange}
              onBlur={onBlur}
            />
          )}
        </>
      );
    default:
      return assertNever(width);
  }
};
